export default {
	"server_host":"https://berenice.snapquick.app/",
	"app_data":"app-datos/app-snapquick.json"
 }